/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_DirectionInputs */

const en_reference_field_direction = /** @type {(inputs: Reference_Field_DirectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Side`)
};

/**
* | output |
* | --- |
* | "Side" |
*
* @param {Reference_Field_DirectionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_direction = /** @type {((inputs?: Reference_Field_DirectionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_DirectionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_direction(inputs)
});